import type { SVGProps } from "react";
import * as React from "react";

const SvgCpu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cpu_svg__a)">
      <path
        fill="currentColor"
        d="M9 9V8a1 1 0 0 0-1 1zm6 0h1a1 1 0 0 0-1-1zm0 6v1a1 1 0 0 0 1-1zm-6 0H8a1 1 0 0 0 1 1zm1-14a1 1 0 1 0-2 0zM8 4a1 1 0 0 0 2 0zm8-3a1 1 0 1 0-2 0zm-2 3a1 1 0 1 0 2 0zm-4 16a1 1 0 1 0-2 0zm-2 3a1 1 0 1 0 2 0zm8-3a1 1 0 1 0-2 0zm-2 3a1 1 0 1 0 2 0zm6-15a1 1 0 1 0 0 2zm3 2a1 1 0 1 0 0-2zm-3 3a1 1 0 1 0 0 2zm3 2a1 1 0 1 0 0-2zM1 8a1 1 0 0 0 0 2zm3 2a1 1 0 1 0 0-2zm-3 3a1 1 0 1 0 0 2zm3 2a1 1 0 1 0 0-2zM6 5h12V3H6zm12 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v12h2V6zm0 12a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H6v2h12zM6 19a1 1 0 0 1-1-1H3a3 3 0 0 0 3 3zm-1-1V6H3v12zM5 6a1 1 0 0 1 1-1V3a3 3 0 0 0-3 3zm4 4h6V8H9zm5-1v6h2V9zm1 5H9v2h6zm-5 1V9H8v6zM8 1v3h2V1zm6 0v3h2V1zM8 20v3h2v-3zm6 0v3h2v-3zm6-10h3V8h-3zm0 5h3v-2h-3zM1 10h3V8H1zm0 5h3v-2H1z"
      />
    </g>
    <defs>
      <clipPath id="cpu_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCpu;
